import  CashReportActions from './actions';

const INITIAL_STATE = {
  data: {},
  dataReport: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperCashReport:[],
  errorInternal:false,
  printCashReport:null
};

function  CashReportReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case  CashReportActions.RESET_LIST:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,data:{}};
    case  CashReportActions.NEW_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, errorMessage:[],form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case  CashReportActions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case  CashReportActions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,errorMessage:[],isNewRecord:false,showModal:true};
    case  CashReportActions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case  CashReportActions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case  CashReportActions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case  CashReportActions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case  CashReportActions.SHOW_DATA_REPORT:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, dataReport: action.payload, errorMessage: [],isProcessing:false };  
    case  CashReportActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case  CashReportActions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case  CashReportActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    case  CashReportActions.GET_HELPER_CASHREPORT:
      return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperCashReport:action.payload};
    case  CashReportActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case CashReportActions.BEFORE_PRINT_CASHREPORT:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printCashReport:null,isProcessing:true};
    case CashReportActions.PRINT_CASHREPORT:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printCashReport:action.payload,isProcessing:false};       
    default:
      return state;
    }
}

export default CashReportReducer;
